<template>
    <footer class="footer mt-auto py-3 bg-dark">
      <div class="container text-center text-light">
        <span>&copy; 2024 里世界玩家终端. QQ:314733645</span>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'Footer',
  };
  </script>
  
  <style scoped>
  </style>
  